import api from "./index";

export interface CompanyListParams {
  ids?: Array<string>;
  title?: string;
  ownerIds?: Array<string>;
  employeesIds?: Array<string>;
  enabled?: boolean;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: CompanyListParams, options?: any) => {
  return api.CompanyApi.list(
    params.ids,
    params.title,
    params.ownerIds,
    params.employeesIds,
    params.enabled,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.offset,
    params.limit,
    options
  );
};
